import { PrefectureId, prefectures, PrefectureSlug } from '@gyym/sdk'

export const getPrefectureById = (prefectureId: PrefectureId) => {
  return prefectures.find(({ id }) => id === prefectureId)
}

export const getPrefectureSlugById = (prefectureId: PrefectureId) => {
  const entry = prefectures.find(({ id }) => id === prefectureId)
  return entry ? entry.slug : null
}

export const getPrefectureBySlug = (slug: PrefectureSlug) => {
  return prefectures.find(({ slug: prefectureSlug }) => prefectureSlug === slug)
}

export const prefectureSlugExists = (slug: string) => {
  return prefectures.some(({ slug: prefectureSlug }) => prefectureSlug === slug)
}
